// extracted by mini-css-extract-plugin
export default {"deleteButton":"Input_deleteButton__xvqLS","fieldSmallerMargin":"Input_fieldSmallerMargin__5yTS1"};